import axios from 'axios'
import {decode} from 'jsog/lib/JSOG'

const toData = response => decode(response.data)

export function addCollaborator(data): Promise {
  return axios.post('/bw/consultation/', data).then(toData)
}

export function deleteCollaborator(id): Promise {
  return axios.delete(`/bw/consultation/${id}`).then(toData)
}

export function getAllCollaboratorsPerScan(id): Promise {
  return axios.get(`/bw/consultation/scan/${id}`).then(toData)
}

export function setCollaboratorsQuestions(data) {
  return axios.post('/bw/consultationquestion/consultations/', data).then(toData)
}

export function getCollaboratorsResponses(scanId, questionId): Promise {
  return axios.get(`/bw/consultationquestion/scan/${scanId}/question/${questionId}`).then(toData)
}

export function deleteCollaboratorQuestion(scanId, questionId) {
  return axios.delete(`/bw/consultationquestion/scan/${scanId}/question/${questionId}`).then(toData)
}


// WEBPACK FOOTER //
// ./src/services/consultation-service.js